import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=cbc096ce&scoped=true&"
import script from "./Invoice.vue?vue&type=script&lang=ts&"
export * from "./Invoice.vue?vue&type=script&lang=ts&"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=cbc096ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc096ce",
  null
  
)

export default component.exports